export const CABANG = {
  STATUS_KAS_VIRTUAL: {
    ACTIVE: 2
  },
  DROP_OFF_POINT_STATUS: {
    TIDAK_DIPERBOLEHKAN: 0,
    DROP_OFF: 1
  },
}